<template>
  <div>
    <el-form
      :model="otaForm"
      :rules="rules"
      ref="otaForm"
      style="margin-right: 30px"
    >
      <el-form-item
        label="更新提示"
        :label-width="formLabelWidth"
        prop="forceUpdate"
      >
        <el-select
          style="margin-right: 30px"
          clearable
          v-model="otaForm.forceUpdate"
          filterable
          placeholder="请选择更新"
        >
          <el-option
            v-for="item in updateOptions"
            :key="item.value"
            :label="item.name"
            :value="item.value"
            :index="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label-width="formLabelWidth" label="">
        <div style="margin-right: 30px">
          <el-button @click="closeDialog">取消</el-button>
          <el-button
            type="primary"
            @click="confirmAction('otaForm')"
            :disabled="disableSubmit"
            >确定，并变更</el-button
          >
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { Message } from "element-ui";
import { modifyOta } from "../../api/otaApi";
import { API_URL, requestHeaders } from "../../api/request";
import { handleResponse } from "../../utils/response";

export default {
  name: "ModifyOtaForm",
  watch: {
    otaInfo(newValue, oldValue) {
      this.otaForm = { ...newValue, projectId: this.project.id };
    },
  },
  created() {},
  mounted() {
    console.log("API_URL-->", API_URL);
    this.otaForm = { ...this.otaInfo, projectId: this.project.id };
    console.log("otaForm-->", this.otaForm);
  },
  methods: {
    closeDialog() {
      this.$refs.otaForm.resetFields();
      this.$emit("clickCancel");
    },
    confirmAction(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          modifyOta(this.otaForm).then((res) => {
            handleResponse(
              res,
              (data) => {
                this.$emit("clickConfirm");
              },
              (error) => {
                Message.error("保存失败");
              }
            );
          });
        } else {
          return false;
        }
      });
    },
  },
  props: {
    project: {
      type: Object,
      default: { id: -1 },
    },
    otaInfo: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      disableSubmit: false,
      uploadHeaders: requestHeaders("/ota/modify"),
      uploadActionUrl: API_URL + "/ota/modify",
      rules: {
        forceUpdate: [
          {
            required: true,
            message: "请选择固件类型",
            trigger: "change",
          },
        ],
      },
      updateOptions: [
        {
          name: "建议更新",
          value: 2,
        },
        {
          name: "强制更新",
          value: 1,
        },
        {
          name: "无提示",
          value: 0,
        },
      ],
      otaForm: {
        projectId: -1,
        version: "",
        description: "",
        uploadFile: null,
        forceUpdate: 2,
        type: 1,
        addr: "",
        socType: "",
        otaType: null,
      },
      formLabelWidth: "100px",
    };
  },
};
</script>

<style scoped></style>
